import { render, staticRenderFns } from "./Emergencia.vue?vue&type=template&id=2e22d3d9&scoped=true"
import script from "./Emergencia.vue?vue&type=script&lang=js"
export * from "./Emergencia.vue?vue&type=script&lang=js"
import style0 from "./Emergencia.vue?vue&type=style&index=0&id=2e22d3d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e22d3d9",
  null
  
)

export default component.exports